import { StyleSheet, View, Text, Svg, Line, Image } from '@react-pdf/renderer'
import React, { Fragment, useEffect, useState } from 'react'
import logo from "assets/logo_pdf.png"
import { useLocalStorage } from 'hooks/useLocalStorage'
import { MyConst } from 'data/MyConst'

const styles = StyleSheet.create({
    container: { display: "flex", flexDirection: 'row', alignItems: "center", minHeight: "79px" },
    logoWrap: {
        textAlign: "center",
        display: "flex",
        width: "15%",
        height: "79px",
        justifyContent: "center",
        alignItems: "center",
    },
    logo: { width: 79, height: 74, objectFit: "contain", marginBottom: 5 },
    headerTextWrap: { textAlign: "center", display: "flex", width: "70%", justifyContent: "center" },
    headerSideSpacer: { width: "15%" },
    text11Bold: { fontSize: 11, fontFamily: 'Helvetica-Bold' },
    text10Bold: { fontSize: 10, fontFamily: 'Helvetica-Bold' },
    contactText: { fontSize: 8 },
    contactTextSpaced: { fontSize: 8, marginTop: 3 },
})

function assetUrl(location, filename) {
    if (!filename) return ""
    const base = String(MyConst.URLASET || "").replace(/\/$/, "")
    return `${base}/${location}/${filename}`
}

const imageDataURLCache = new Map()

function blobToDataURL(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
    })
}

async function cachedImageDataURL(url) {
    if (!url) return ""
    if (imageDataURLCache.has(url)) {
        return imageDataURLCache.get(url)
    }
    const response = await fetch(url, { cache: "force-cache" })
    if (!response.ok) {
        return ""
    }
    const dataUrl = await blobToDataURL(await response.blob())
    imageDataURLCache.set(url, dataUrl)
    return dataUrl
}

function buildContactLine(header = {}) {
    const alamat = header?.alamat || MyConst.ALAMAT
    const sekretariat = alamat || ""
    const webEmail = [
        header?.website ? `Web: ${header.website}` : "",
        header?.email ? `Email: ${header.email}` : "",
        header?.telepon ? `Telp. ${header.telepon}` : "",
    ].filter(Boolean).join(", ")
    return { sekretariat, webEmail }
}

const PDFPageHeader = (props) => {
    const [user] = useLocalStorage("user", null)
    const header = props?.pdfHeader || user?.pdf_header || {}
    const remoteLogoSrc = header?.logo ? assetUrl("organisasi-logo", header.logo) : ""
    const [logoSrc, setLogoSrc] = useState(() => (remoteLogoSrc && imageDataURLCache.get(remoteLogoSrc)) || logo)
    const contact = buildContactLine(header)
    const sekretariatStyle = header?.klub ? styles.contactText : styles.contactTextSpaced

    useEffect(() => {
        let cancelled = false
        if (!remoteLogoSrc) {
            setLogoSrc(logo)
            return () => {
                cancelled = true
            }
        }
        const cached = imageDataURLCache.get(remoteLogoSrc)
        if (cached) {
            setLogoSrc(cached)
            return () => {
                cancelled = true
            }
        }
        cachedImageDataURL(remoteLogoSrc)
            .then((dataUrl) => {
                if (!cancelled && dataUrl) setLogoSrc(dataUrl)
            })
            .catch(() => {
                if (!cancelled) setLogoSrc(logo)
            })
        return () => {
            cancelled = true
        }
    }, [remoteLogoSrc])

    return (
        <Fragment>
            <View style={styles.container}>
                <View style={styles.logoWrap}>
                    <Image src={logoSrc || logo} style={styles.logo} />
                </View>
                <View style={styles.headerTextWrap}>
                    <Text style={styles.text11Bold}>KOMITE OLAHRAGA NASIONAL INDONESIA</Text>
                    <Text style={styles.text11Bold}>{String(header?.koni_wilayah || MyConst.PDF_HEADER_3 || "").toUpperCase()}</Text>
                    {header?.induk_organisasi ? <Text style={styles.text10Bold}>{header.induk_organisasi}</Text> : null}
                    {header?.klub ? <Text style={styles.text10Bold}>{header.klub}</Text> : null}
                    {contact.sekretariat ? <Text style={sekretariatStyle}>{contact.sekretariat}</Text> : null}
                    {contact.webEmail ? <Text style={styles.contactText}>{contact.webEmail}</Text> : null}
                    <Text>{"\n"}</Text>
                </View>
                <View style={styles.headerSideSpacer} />
            </View>
            <Svg height="4" width="100%">
                <Line x1="0" y1="0" x2="2000" y2="0" strokeWidth={6} stroke="rgb(0,0,0)" />
            </Svg>
            <Svg height="1" width="100%">
                <Line x1="0" y1="0" x2="2000" y2="0" strokeWidth={2} stroke="rgb(0,0,0)" />
            </Svg>
            <View><Text>{"\n"}</Text></View>
        </Fragment>
    )
}

export default PDFPageHeader
